/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type SegmentParameter,
    SegmentParameterFromJSON,
    SegmentParameterToJSON,
} from '../models/SegmentParameter';

export interface DeleteParametersRequest {
    id: string;
}

export interface GetAllParametersRequest {
    id: string;
}

export interface UpdateParametersRequest {
    id: string;
    segmentParameter: Array<SegmentParameter>;
}

/**
 * 
 */
export class SegmentParameterApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteParameters without sending the request
     */
    async deleteParametersRequestOpts(requestParameters: DeleteParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/parameter`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteParametersRaw(requestParameters: DeleteParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteParameters(requestParameters: DeleteParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteParametersRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllParameters without sending the request
     */
    async getAllParametersRequestOpts(requestParameters: GetAllParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/parameter`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllParametersRaw(requestParameters: GetAllParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SegmentParameter>>> {
        const requestOptions = await this.getAllParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SegmentParameterFromJSON));
    }

    /**
     */
    async getAllParameters(requestParameters: GetAllParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SegmentParameter>> {
        const response = await this.getAllParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateParameters without sending the request
     */
    async updateParametersRequestOpts(requestParameters: UpdateParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateParameters().'
            );
        }

        if (requestParameters['segmentParameter'] == null) {
            throw new runtime.RequiredError(
                'segmentParameter',
                'Required parameter "segmentParameter" was null or undefined when calling updateParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/parameter`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['segmentParameter']!.map(SegmentParameterToJSON),
        };
    }

    /**
     */
    async updateParametersRaw(requestParameters: UpdateParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SegmentParameter>>> {
        const requestOptions = await this.updateParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SegmentParameterFromJSON));
    }

    /**
     */
    async updateParameters(requestParameters: UpdateParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SegmentParameter>> {
        const response = await this.updateParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
